








































































































import { Vue, Component } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import QtyPicker from "@/components/elements/utility/QtyPicker.vue";
import {
  ConfigType,
  QuickshipConfigFile
} from "@/models/configurator/config_file";
import ProductService from "@/services/product_service";
import { makeTitleCase } from "@/utility/helpers";
import { LineItem } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions } from "@/store/modules/order/types";
import AddListToQuoteFooter from "@/components/footer/AddListToQuoteFooter.vue";
import { AuthError, GenericError } from "@/services/error_service";
import { getFinishName } from "@/utility/helpers";
import { CustomUmbrella } from "@/models/configurator/custom_umbrella";
import { EventBus } from "@/event-bus";
import { mixins } from "vue-class-component";
import { Mobile } from "@/mixins/mobile";
import { GlobalGetters } from "@/store/modules/global/types";
@Component({
  components: {
    Search,
    DataTable,
    QtyPicker,
    AddListToQuoteFooter
  }
})
export default class QuickshipList extends mixins(Mobile) {
  @(namespace(StoreModule.Order).Action(OrderActions.AddLineItem))
  addItem!: (value: LineItem) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: number;
  private search = "";
  protected makeTitleCase = makeTitleCase;
  protected prices: { _id: string; price: number }[] = [];
  protected fields = [
    "fabric",
    "frame",
    "model",
    "collection",
    // "model",
    "size",
    "shape",
    // "base",
    "price",
    "multiplier",
    "quantity"
  ];
  protected productService = new ProductService();
  protected quickshipItems: QuickshipConfigFile[] = [];
  protected lineItems: LineItem[] = [];
  protected ProductType = ProductType;
  protected loader: any = null;

  async created() {
    this.showLoader();
    try {
      this.quickshipItems = await this.productService.getQuickshipFiles();
      await this.fetchAllPrices();
    } catch (err) {
      GenericError.popup(err.message);
    }
    this.closeLoader();
  }

  protected showLoader(): void {
    this.loader = this.$loading.show(
      {
        opacity: 1
      },
      {
        before: this.$createElement("h1", {
          domProps: { innerHTML: "Loading quickship umbrellas..." }
        })
      }
    );
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }

  get cdnUrl(): string {
    return process.env.VUE_APP_CDN_URL;
  }

  get itemPriceTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty * item.multiplier;
    }
    return price;
  }

  get msrpTotal(): number {
    let price = 0;
    for (const item of this.lineItems) {
      price = price + item.unit_price * item.qty;
    }
    return price;
  }

  protected async fetchAllPrices(): Promise<void> {
    for (const item of this.quickshipItems) {
      const price = await this.getCustomUmbrellaPrice(item);
      if (price) {
        this.prices.push({
          _id: item._id!,
          price: price.umbrella + price.base
        });
      }
    }
  }

  /**
   * The getCustomPrice() method expects an object in format of CustomUmbrella, so we have
   * to first convert the file from ConfigFile format to CustomUmbrella format. ConfigFile comes
   * directly from the database and has shorthand references (i.e. finish: 'bz' vs the entire
   * finish object; finish: {display_name: 'Bronze', handle: 'bz'})
   *
   * This logic originates from Shade Designer
   */
  protected async getCustomUmbrellaPrice(
    item: QuickshipConfigFile
  ): Promise<any> {
    const data = Object.assign({}, {
      layout: item.layout,
      shape: item.shape,
      frame: item.frame,
      base: item.base,
      canopy: item.canopy
    } as any) as CustomUmbrella;
    if (item.base.base) {
      data.base = Object.assign(
        {},
        { ...data.base },
        { base: item.baseObject![0] },
        {
          baseFinish: {
            display_name: getFinishName(item.base.baseFinish!),
            handle: item.base.baseFinish
          }
        }
      );
    }
    data.frame = Object.assign(
      {},
      { ...data.frame },
      {
        finish: {
          display_name: getFinishName(item.frame.finish),
          handle: item.frame.finish
        }
      }
    );
    data.shape = Object.assign(
      {},
      { ...data.shape },
      { model: item.umbrella![0] }
    );
    data.canopy = Object.assign(
      {},
      { ...data.canopy },
      { mainFabric: item.fabric }
    );
    let price;
    try {
      price = await this.productService.getCustomPrice(data, true);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
    return price;
  }

  protected getPrice(id: string): number {
    const price = this.getNumberPrice(id);
    return price ? price : 0;
  }

  protected getNumberPrice(id: string): number {
    const obj = this.prices.find(price => price._id === id);
    return obj ? obj.price : 0;
  }

  protected addToQuote() {
    for (const item of this.lineItems) {
      this.addItem(item);
    }
    EventBus.$emit("addToCartModal", {
      qty: this.lineItems.length,
      quickshipList: this.lineItems
    });
  }

  protected setQty(qty: number, id: string): void {
    this.triggerUpdate(id, { qty });
  }

  protected setMultiplier(id: string, multiplier: number): void {
    this.triggerUpdate(id, { multiplier });
  }

  protected triggerUpdate(
    id: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    if (options.qty === 0) {
      this.removeLineItem(id);
    } else {
      this.updateLineItem(id, options);
    }
  }

  protected removeLineItem(id: string): void {
    this.lineItems = this.lineItems.filter(item => item._id !== id);
  }

  protected updateLineItem(
    id: string,
    options: { qty?: number; multiplier?: number }
  ): void {
    const index = this.lineItems.findIndex(item => item._id === id);
    if (index > -1) {
      const obj = { ...this.lineItems[index] };
      obj.qty = options.qty ? options.qty : obj.qty;
      obj.multiplier = options.multiplier ? options.multiplier : obj.multiplier;
      this.lineItems.splice(index, 1, obj);
    } else if (options.qty) {
      this.addNewLineItem(id, options);
    }
  }

  protected addNewLineItem(
    id: string,
    options: { qty?: number; multiplier?: number }
  ) {
    const refMultiplier = this.$refs[id]![0].value
      ? this.$refs[id]![0].value
      : 1.0;
    const item = this.quickshipItems.find(item => item._id === id);
    const itemObj = {
      _id: id,
      product_type: ProductType.Umbrella,
      multiplier: refMultiplier,
      type: ConfigType.QS,
      sku: "",
      model: item!.shape!.model,
      product_line: item!.layout.productline!.handle,
      qty: options.qty!,
      unit_price: this.getNumberPrice(item!._id!),
      display_name: item!.umbrella![0].display_name,
      notes: "",
      item_details: { canopy: { ...item!.canopy }, frame: { ...item!.frame } }
    };
    this.lineItems.push(itemObj as any);
  }
  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  /** Remove unneeded fields from fetched data & perform search before returning data to view */
  get filteredItems() {
    if (this.search != "") {
      const filterModel = (this.quickshipItems as any[]).filter(item => {
        return (
          item.shape.model.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
      const filterCol = (this.quickshipItems as any[]).filter(item => {
        return (
          item.layout.productline.handle
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
      const filterFabric = (this.quickshipItems as any[]).filter(item => {
        return (
          item.fabric[0].mfr_code
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
      return filterModel.concat(filterCol, filterFabric);
    } else {
      return this.quickshipItems;
    }
  }
}
